import { type PropType, type Component } from "vue";
import { UiIconAttention } from "../../icons";
import { type TooltipPlacement } from "../tooltip/tooltip";

export interface QuestionMarkTooltipProps {
    icon?: Component;
    text?: string;
    placement?: TooltipPlacement;
    maxWidth?: string;
    disabled?: boolean;
}

export const questionMarkTooltipProps = {
    icon: {
        type: [Object, Function] as PropType<QuestionMarkTooltipProps["icon"]>,
        default: () => UiIconAttention,
        required: false,
    },
    text: {
        type: String as PropType<QuestionMarkTooltipProps["text"]>,
        default: undefined,
        required: false,
    },
    placement: {
        type: String as PropType<QuestionMarkTooltipProps["placement"]>,
        // Конкретная сторона теперь жёсткая и у края экрана уводит подсказку
        // за границу, поэтому по умолчанию подбираем сторону по месту.
        default: "auto",
        required: false,
    },
    maxWidth: {
        type: String as PropType<QuestionMarkTooltipProps["maxWidth"]>,
        default: "max-content",
        required: false,
    },
    disabled: {
        type: Boolean as PropType<QuestionMarkTooltipProps["disabled"]>,
        default: false,
        required: false,
    },
};
